module.exports = __webpack_public_path__ + "img/lira-sign.22651385.svg";